<template>
    <module-card :nextFunction="unlockResources">
        <v-img class="mx-auto" :max-width="300" :src="require('@/assets/GoinDownhillFast/crystalPoppers.png')" alt="Crystal Meth, cocaine"></v-img>
        <p class="text-subtitle-2 font-weight-bold text-center">Crystal Meth, poppers, cocaine, crack</p>
        <p>
            These drugs are called “stimulants” because they WAKE UP the body’s systems. The problem is that people can become hooked after only using them once. People say when they use stimulants they “give zero f*cks.” But once they lose
            their high, it can all go downhill FAST.
        </p>
        <p>
            People on stimulants might ignore their BottomLine, taking risks they never meant to take. Poppers relax the butthole (anus), which can lead to tears and bleeding when bottoming. Some people may use poppers so much they can’t
            enjoy sex without them – aww. :(
        </p>
        <p>
            <external-link href="https://teens.drugabuse.gov/drug-facts/inhalants" target="_blank">Click here to learn about poppers</external-link>
        </p>
        <p>
            Sometimes people use drugs like cocaine, crack, and crystal meth to keep themselves awake for looong periods. They’re SUPER highly addictive -- some people become addicted after only one use. And, this class of drugs can be
            really toxic to the body and brain.
        </p>
        <p>
            <external-link href="https://teens.drugabuse.gov/drug-facts/cocaine" target="_blank">Click here to learn more about cocaine</external-link> and
            <external-link href="https://teens.drugabuse.gov/drug-facts/methamphetamine-meth" target="_blank">here to learn about crystal meth</external-link>
        </p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'Drugs and Alcohol' && (o.topic === 'Poppers' || o.topic === 'Cocaine' || o.topic === 'Crystal Meth')) {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
